var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-bottom": "20px" } },
        [
          _vm.$parent.checkPer(["admin", "customers:followAdd"])
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.openAddFollowDialog },
                },
                [_vm._v("\n      新增跟进\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增跟进记录",
            visible: _vm.showFollowDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFollowDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "followForm",
              attrs: { model: _vm.form, size: "small", "label-width": "100px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进人" } },
                        [
                          _vm._l(_vm.form.followUser, function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item,
                                staticStyle: { "margin-right": "2px" },
                              },
                              [_vm._v(_vm._s(item))]
                            )
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: { icon: "el-icon-plus" },
                            on: {
                              click: function ($event) {
                                return _vm.onUserSelect("跟进人")
                              },
                            },
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: {
                              width: "100%",
                              "min-width": "200px",
                            },
                            attrs: {
                              type: "datetime",
                              placeholder: "请选择跟进时间",
                              "default-value": new Date(),
                            },
                            model: {
                              value: _vm.form.followTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "followTime", $$v)
                              },
                              expression: "form.followTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择跟进类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.followType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "followType", $$v)
                                },
                                expression: "form.followType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "电话", value: "电话" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "微信", value: "微信" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "上门", value: "上门" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "其他", value: "其他" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "步骤" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择步骤",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.step,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "step", $$v)
                                },
                                expression: "form.step",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "初次接触", value: "初次接触" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "需求分析", value: "需求分析" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "方案设计", value: "方案设计" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "签约", value: "签约" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "售后", value: "售后" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "通话时长" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入通话时长（分钟）" },
                            model: {
                              value: _vm.form.callDuration,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "callDuration", $$v)
                              },
                              expression: "form.callDuration",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进内容" } },
                        [
                          _c("el-input", {
                            attrs: {
                              rows: 4,
                              type: "textarea",
                              placeholder: "请输入跟进内容",
                            },
                            model: {
                              value: _vm.form.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "content", $$v)
                              },
                              expression: "form.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "附件" } }, [
                        _c(
                          "div",
                          [
                            _c("CommonUpload", {
                              ref: "commonUpload",
                              on: {
                                uploadSuccess: _vm.uploadImgs,
                                delSuccess: _vm.delImg,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showFollowDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.doSubmit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("template", { slot: "header" }, [
            _c("div", { staticClass: "clearfix" }, [
              _c("span", [_vm._v("跟进记录")]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-timeline",
            { attrs: { reverse: _vm.reverse } },
            _vm._l(_vm.followList, function (activity, index) {
              return _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: { timestamp: activity.createTime, placement: "top" },
                },
                [
                  _c("el-card", { staticStyle: { width: "100%" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "follow-content",
                        staticStyle: {
                          "font-weight": "bold",
                          "margin-bottom": "12px",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(activity.followContent) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "follow-meta",
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "wrap",
                          gap: "15px",
                          "margin-bottom": "12px",
                          "font-size": "14px",
                        },
                      },
                      [
                        _c("div", { staticClass: "meta-item" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "margin-right": "4px",
                              },
                            },
                            [_vm._v("跟进类型:")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(activity.followType || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "meta-item" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "margin-right": "4px",
                              },
                            },
                            [_vm._v("跟进时间:")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(activity.followTime || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        activity.callDuration
                          ? _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#909399",
                                    "margin-right": "4px",
                                  },
                                },
                                [_vm._v("通话时长:")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(activity.callDuration) + "分钟"),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "meta-item" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "margin-right": "4px",
                              },
                            },
                            [_vm._v("步骤:")]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(activity.step || "-"))]),
                        ]),
                        _vm._v(" "),
                        activity.createUserName
                          ? _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#909399",
                                    "margin-right": "4px",
                                  },
                                },
                                [_vm._v("创建人:")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(activity.createUserName)),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "follow-user",
                        staticStyle: { "margin-bottom": "12px" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#909399",
                              "margin-right": "4px",
                            },
                          },
                          [_vm._v("跟进人:")]
                        ),
                        _vm._v(" "),
                        _vm.getActivityFollowNames(activity.followName).length >
                        0
                          ? _c(
                              "span",
                              _vm._l(
                                _vm.getActivityFollowNames(activity.followName),
                                function (name, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      staticStyle: { "margin-right": "6px" },
                                    },
                                    [_vm._v(_vm._s(name))]
                                  )
                                }
                              ),
                              1
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.getActivityImages(activity.image).length > 0
                      ? _c("div", { staticStyle: { "margin-top": "12px" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                "margin-bottom": "8px",
                                color: "#303133",
                              },
                            },
                            [_vm._v("附件:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                                gap: "10px",
                              },
                            },
                            _vm._l(
                              _vm.getActivityImages(activity.image),
                              function (file, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: {
                                      "text-align": "center",
                                      position: "relative",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleFilePreview(file)
                                      },
                                    },
                                  },
                                  [
                                    _vm.isImage(file)
                                      ? [
                                          _c("el-image", {
                                            staticStyle: {
                                              height: "80px",
                                              width: "80px",
                                              "border-radius": "4px",
                                            },
                                            attrs: {
                                              src: _vm.getFileUrl(file),
                                              "preview-src-list": [
                                                _vm.getFileUrl(file),
                                              ],
                                            },
                                          }),
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                height: "80px",
                                                width: "80px",
                                                "border-radius": "4px",
                                                "background-color": "#f5f7fa",
                                                display: "flex",
                                                "align-items": "center",
                                                "justify-content": "center",
                                                border: "1px solid #ebeef5",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center",
                                                    padding: "5px",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-document",
                                                    staticStyle: {
                                                      "font-size": "24px",
                                                      color: "#909399",
                                                      "margin-bottom": "5px",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "word-break":
                                                          "break-all",
                                                        "max-width": "60px",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getFileName(file)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              }
                            ),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }